import { render, staticRenderFns } from "./DocumentLabelModal.vue?vue&type=template&id=15e284d3"
import script from "./DocumentLabelModal.vue?vue&type=script&lang=js"
export * from "./DocumentLabelModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports